import { render, staticRenderFns } from "./SHProposalInsureds.vue?vue&type=template&id=d0c9f678"
import script from "./SHProposalInsureds.vue?vue&type=script&lang=js"
export * from "./SHProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports